import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { GenericDocMessageTemplateContainer } from '../../../../../../models/aggregates/generic_doc';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({providedIn: 'root'})
export class GenericDocMessageTemplateExtService extends BaseApiTemplateService<GenericDocMessageTemplateContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'message-templates-ext/' + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'message-templates-ext/' + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }
}
